const LETTERS: Record<string, string> = {
	а: "a",
	б: "b",
	в: "v",
	г: "g",
	д: "d",
	е: "e",
	ё: "e",
	ж: "zh",
	з: "z",
	и: "i",
	й: "y",
	к: "k",
	л: "l",
	м: "m",
	н: "n",
	о: "o",
	п: "p",
	р: "r",
	с: "s",
	т: "t",
	у: "u",
	ф: "f",
	х: "h",
	ц: "ts",
	ч: "ch",
	ш: "sh",
	щ: "sch",
	ъ: "",
	ы: "y",
	ь: "",
	э: "e",
	ю: "yu",
	я: "ya",
}

const PREFIX = "utm_"
const MAX_LENGTH = 64

export function makeCode(name: string, taken: ReadonlySet<string>): string {
	const slug = [...name.trim().toLocaleLowerCase()]
		.map((char) => LETTERS[char] ?? char)
		.join("")
		.replace(/[^a-z0-9]+/g, "_")
		.replace(/^_+|_+$/g, "")
	if (!slug) return ""

	const base = `${PREFIX}${slug}`.slice(0, MAX_LENGTH - 4).replace(/_+$/, "")
	let code = base
	for (let n = 2; taken.has(code); n++) code = `${base}_${n}`
	return code
}
